
import React from "react";
import { ArrowLeft, MoreVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Person } from "@/types";

interface PersonHeaderProps {
  person: Person;
  onBackClick?: () => void;
}

const PersonHeader: React.FC<PersonHeaderProps> = ({ person, onBackClick }) => {
  const getCategoryInTurkish = (category: string) => {
    switch (category) {
      case 'laborer':
        return 'Usta';
      case 'supplier':
        return 'Tedarikçi';
      case 'subcontractor':
        return 'Alt Yüklenici';
      default:
        return category;
    }
  };

  return (
    <div className="relative bg-card shadow-sm rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {onBackClick && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onBackClick}
              className="mr-1"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
          <div>
            <h2 className="text-xl font-semibold">{person.name}</h2>
            <p className="text-sm text-muted-foreground">
              {getCategoryInTurkish(person.category)}
              {person.specialty && (
                <>
                  <span className="mx-1">•</span>
                  {person.specialty}
                </>
              )}
            </p>
          </div>
        </div>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default PersonHeader;
